import React from 'react';
import { createQueryDataTable, type PropsOfQueryDataTable, type RowOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { baseTotalColumns } from '../../groups/GroupedTotalsColumn';
import { NeedsAssignedScheduleReportTable } from './NeedsAssignedTable';
import { GroupVisitsByPatientTable } from '../../groups/GroupVisitsByPatientTable';

const NeedsAssignedPatientDataTable = createQueryDataTable('schedule-report-totals-patient-unassigned');
type RowType = RowOfQueryDataTable<typeof NeedsAssignedPatientDataTable>;

const columnDefinitions = NeedsAssignedPatientDataTable.columns([
	{
		header: 'Patient',
		key: 'patientName',
		sortable: true
	},
	{
		header: 'MR#',
		key: 'patientCode',
		sortable: true
	},
	...baseTotalColumns<RowType>()
]);

export function NeedsAssignedPatientTable(props: PropsOfQueryDataTable<typeof NeedsAssignedPatientDataTable>) {
	return (
		<GroupVisitsByPatientTable
			columnDefinitions={columnDefinitions}
			searchType="schedule-report-totals-patient-unassigned"
			tableComponent={NeedsAssignedScheduleReportTable}
			{...props}
		/>
	);
}
